import React from 'react';
import { withGoogleMap, GoogleMap, Marker } from 'react-google-maps';

const VanillaGoogleMap = withGoogleMap(props => {
  const { setCoords, lat, lng, zoom } = props;
  const position = lat && lng ? { lat, lng } : undefined;
  const googleMapProps = {
    zoom,
    defaultCenter: { lat: 3.14567, lng: 101.697471 }
  };
  if (position) {
    googleMapProps.center = position;
  }
  return (
    <GoogleMap {...googleMapProps}>
      {position && (
        <Marker
          position={position}
          draggable={true}
          onDragEnd={e => {
            setCoords({ lat: e.latLng.lat(), lng: e.latLng.lng() });
          }}
        />
      )}
    </GoogleMap>
  );
});
export default VanillaGoogleMap;
